import { Wordmark, GoldDivider, Eyebrow, EditorialHeading } from "../../components/brand";
import SectionHeader from "../../components/shared/SectionHeader";
import { Link } from "react-router-dom";
import { BUSINESS_INFO } from "../../content/site";

export default function About() {
  const founder = BUSINESS_INFO.founder;
  return (
    <div data-testid="page-about">
      <section className="bg-altura-ivory py-24">
        <div className="container-editorial max-w-4xl">
          <Eyebrow>About Altura Global</Eyebrow>
          <EditorialHeading size="xl" className="mt-4">A different kind of international investment firm.</EditorialHeading>
          <GoldDivider className="mt-6" />
          <div className="mt-8 space-y-6 text-lg text-altura-charcoal/80 leading-relaxed">
            <p>Altura Global is a premium international real estate and global investment platform. We help investors, entrepreneurs, professionals, families, and members of the African diaspora explore carefully selected international markets — with Ghana as our flagship.</p>
            <p>{BUSINESS_INFO.mission}</p>
          </div>
        </div>
      </section>

      <section className="bg-altura-beige/40 py-24">
        <div className="container-editorial">
          <div className="grid md:grid-cols-4 gap-6" data-testid="about-stats">
            {BUSINESS_INFO.stats.map((s) => (
              <div key={`stat-${s.label}`} className="text-center border border-altura-gold/25 rounded-lg py-8 bg-white/60">
                <div className="font-editorial text-4xl text-altura-espresso">{s.value}</div>
                <div className="mt-2 text-[11px] uppercase tracking-[0.2em] text-altura-charcoal/60">{s.label}</div>
              </div>
            ))}
          </div>
          <p className="mt-6 text-[11px] text-altura-charcoal/50 text-center">Figures publicly stated by Altura Property Group.</p>
        </div>
      </section>

      <section className="bg-altura-ivory py-24">
        <div className="container-editorial grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-5">
            <img src="https://images.pexels.com/photos/32803403/pexels-photo-32803403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900" alt="Accra" className="rounded-lg aspect-square object-cover" />
          </div>
          <div className="lg:col-span-7">
            <Eyebrow>Why Ghana</Eyebrow>
            <EditorialHeading size="md" className="mt-4">A flagship market chosen with intention.</EditorialHeading>
            <GoldDivider className="mt-6" />
            <p className="mt-6 text-altura-charcoal/75 leading-relaxed">
              Ghana anchors the Altura Global thesis because it combines political stability, English-common-law inheritance, a diaspora coming home, and a maturing property market that rewards patience. We know Ghana deeply — its neighborhoods, its developers, its diligence requirements — and we exist to help you know it too.
            </p>
            <p className="mt-4 text-altura-charcoal/75 leading-relaxed">
              Beyond Ghana, we represent a small, curated set of international destinations: Kenya, Nigeria, Tanzania, Dubai, and Punta Cana. Each was selected for its own thesis — never because it was easy to add.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-altura-beige/40 py-24">
        <div className="container-editorial">
          <SectionHeader eyebrow="Founder" title="A founder-led firm." align="left" size="md" />
          <div className="mt-12 grid lg:grid-cols-12 gap-14 items-center">
            <div className="lg:col-span-4">
              <div className="relative aspect-[4/5] rounded-lg overflow-hidden bg-altura-ivory-2 shadow-[0_28px_60px_-24px_rgba(20,20,25,0.25)] group">
                <img
                  src="https://customer-assets-4nw71qhi.emergentagent.net/job_invest-beyond-2/artifacts/d4vl6qna_toia.png"
                  alt={`${founder.name}, ${founder.title}`}
                  loading="lazy"
                  className="h-full w-full object-cover object-top transition-transform duration-[1400ms] ease-out group-hover:scale-[1.03]"
                  data-testid="founder-portrait"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-altura-espresso/25 via-transparent to-transparent" />
              </div>
            </div>
            <div className="lg:col-span-8">
              <div className="font-editorial text-3xl text-altura-espresso" data-testid="founder-name">{founder.name}</div>
              <div className="mt-1 text-sm text-altura-gold-dark">{founder.title}</div>
              <GoldDivider className="mt-5" />
              <p className="mt-6 text-altura-charcoal/80 leading-relaxed">
                {founder.bio}
              </p>
              <p className="mt-4 text-altura-charcoal/75 leading-relaxed">
                Our founder-led approach means every client relationship carries the same standard: education first, relationships second, and transactions only when the fit is right.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-altura-espresso text-altura-ivory py-24 relative noise">
        <div className="container-editorial relative z-10 text-center">
          <Eyebrow className="text-altura-gold mx-auto">Ready to Begin?</Eyebrow>
          <EditorialHeading size="lg" className="mt-4 text-altura-ivory">Curated. Considered. Global.</EditorialHeading>
          <p className="mt-5 mx-auto max-w-2xl text-altura-ivory/70">
            We are not building the largest firm. We are building the one that clients recommend to their family — because that is the market we want to earn our place in.
          </p>
          <div className="mt-9 flex flex-wrap justify-center gap-3">
            <Link to="/contact" className="btn-gold">Request Information</Link>
            <Link to="/consultation" className="btn-outline-gold border-altura-ivory/70 text-altura-ivory hover:bg-altura-ivory/10">
              Schedule a Consultation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
